var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('path',{ref:"path",class:{'has-data': _vm.country.data},attrs:{"id":_vm.country.id,"d":_vm.country.d},on:{"click":_vm.onClick}})}
var staticRenderFns = []

export { render, staticRenderFns }